import { Attributes, Misc, Validation, ValueObject } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import FieldConfigValues from './FieldConfig/FieldConfigValues';
import CorrespondenceConfigValues from './CorrespondenceConfig';
import { ExportConfig } from './ExportConfig';
import { ReportingConfigValues } from './ReportingConfig';


export class ConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Integer()
    public dividendAccrualProjectionMonths: number = 12;

    public tenantIdentifier: string | null = null;

    public preAuthEnabled: boolean = false;

    public authorisationRequiredForTransactions: boolean = false;

    public authorisationRequiredForReporting: boolean = false;
    
    public allowChangeUserAuthorisations: boolean = false;

    public distributionWording: string | null = null;

    public systemNoteDays: number = 7;

    public reminderDashboardDays: number = 14;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public tenantName: string | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Config Values";
    }
}

export class TenantConfig extends TemporalEntity {
    static typeName = "TenantConfig";

    constructor() {
        super();
        this.makeObservable();
    }

    public tenantConfigId: number = 0;

    @Attributes.ChildObject(ConfigValues, true)
    public values: ConfigValues = new ConfigValues();

    @Attributes.ChildObject(ReportingConfigValues, true)
    public reportingValues: ReportingConfigValues = new ReportingConfigValues();

    @Attributes.ChildObject(FieldConfigValues, true)
    public fieldValues: FieldConfigValues = new FieldConfigValues();

    @Attributes.ChildObject(CorrespondenceConfigValues)
    public correspondenceValues: CorrespondenceConfigValues | null = null;

    @Attributes.ChildObject(ExportConfig)
    public exportConfig: ExportConfig | null = new ExportConfig();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New tenant config";
        } else {
            return "Tenant Config";
        }
    }
}